import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupByTournamentName',
})
export class GroupByTournamentName implements PipeTransform {
  transform(value, args: string[]): any {
    const groups = {};
    if (value != null)
      if (value.length > 0) {
        value.forEach(function (o) {
          const group = o.TournamentName;
          const icon = o.SportName;
          groups[group] = groups[group] ? groups[group] : { TournamentName: group, SportName: icon, eEvents: [] };
          groups[group].eEvents.push(o);
        });
      }
    return Object.keys(groups).map(function (key) {
      return groups[key];
    });
  }
}
